import React from 'react';
import { connect } from 'react-redux';

import { interfaceActions } from '../../../../../common/redux/actions';
import TopPanel from '../../components/TopPanel/TopPannel';

const { setCaption } = interfaceActions;

class OrderPayment extends React.Component {
  componentDidMount() {}

  render() {
    return (
      <div id="orderPayment">
        <TopPanel />
      </div>
    );
  }
}

export default connect(state => ({}), {
  setCaption,
})(OrderPayment);
